import { format, isValid } from "date-fns";
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY


export function formatDateToDMY(dateString, type) {
  const date = new Date(dateString);

  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();
  if (type) {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}/${month}/${year}`;
  }
}

export function getFormattedTime(dateString) {
  const date = new Date(dateString);

  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  return formatter?.format(date);
}

export function formatDate(inputDate) {
  // Convert the input to a Date object if it's not already
  const date = new Date(inputDate);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const dayOfMonth = date.getDate();
  const month = monthsOfYear[date.getMonth()];

  // Get the appropriate suffix for the day of the month (st, nd, rd, th)
  const suffix =
    dayOfMonth % 10 === 1 && dayOfMonth !== 11
      ? "st"
      : dayOfMonth % 10 === 2 && dayOfMonth !== 12
        ? "nd"
        : dayOfMonth % 10 === 3 && dayOfMonth !== 13
          ? "rd"
          : "th";

  // Check if the provided date is today
  const today = new Date();
  const isToday = date.toDateString() === today.toDateString();

  return `${dayOfWeek}, ${dayOfMonth}${suffix} ${month}${isToday ? " (Today)" : ""
    }`;
}

export function genderfunc(val) {
  if (val == 0) {
    return "Male";
  } else if (val == 1) {
    return "Female";
  } else if (val == 2) {
    return "Unisex";
  } else {
    return "-";
  }
}

export const formattedDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const options = { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export function formatYearAndMonth(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short' };
  return new Intl.DateTimeFormat('en-US', options).format(date);
}



export const capitalize = (str) => {
  if (typeof str !== 'string' || str.length === 0) {
    return 'N/A';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};


export const eventType = {
  "ceception": "Reception",
  "ceremony": "Ceremony",
  "registrar_singing": "Registrar Singing",
};


export const formatEventDetails = (eventDate, eventTime) => {
  try {
    const date = new Date(eventDate);
    const fromTime = new Date(eventTime.from);
    const toTime = new Date(eventTime.to);

    // If you want to display the time in UTC, convert the date to UTC by using the date's UTC components
    const adjustedFromTime = new Date(Date.UTC(fromTime.getUTCFullYear(), fromTime.getUTCMonth(), fromTime.getUTCDate(), fromTime.getUTCHours(), fromTime.getUTCMinutes(), fromTime.getUTCSeconds()));
    const adjustedToTime = new Date(Date.UTC(toTime.getUTCFullYear(), toTime.getUTCMonth(), toTime.getUTCDate(), toTime.getUTCHours(), toTime.getUTCMinutes(), toTime.getUTCSeconds()));

    const formatTime = (date) => {
      const hours = date.getUTCHours(); // Ensure we're using UTC time
      const minutes = date.getUTCMinutes(); // Ensure we're using UTC time
      const isPM = hours >= 12;

      const hour12 = hours % 12 || 12;
      const minuteFormatted = minutes < 10 ? `0${minutes}` : minutes;

      const ampm = isPM ? 'PM' : 'AM';

      return `${hour12}:${minuteFormatted} ${ampm}`;
    };

    const formattedDate = format(date, "EEEE, MMM dd, yyyy").replace(",", "");
    const formattedTime = `${formatTime(adjustedFromTime)} - ${formatTime(adjustedToTime)}`;

    return { formattedDate, formattedTime };
  } catch (error) {
    console.error("Error formatting event details:", error.message);
    return { formattedDate: "-", formattedTime: "-" };
  }
};

export const dateOfBookingEventWise = (eventDates) => {
  if (!Array.isArray(eventDates) || eventDates.length === 0) {
    return "-";
  }

  const validDates = eventDates
    .map(date => new Date(date))
    .filter(date => !isNaN(date));

  if (validDates.length === 0) {
    return "-";
  }

  const earliestDate = validDates.reduce((min, date) =>
    date < min ? date : min
  );

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(earliestDate);
};

export const formatTimeCalenderEvent = (date) => {
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const isPM = hours >= 12;

  const hour12 = hours % 12 || 12;
  const minuteFormatted = minutes < 10 ? `0${minutes}` : minutes;

  const ampm = isPM ? 'PM' : 'AM';

  return `${hour12}:${minuteFormatted} ${ampm}`;
};

export const convertTo12HourFormat = (time) => {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  let hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  hour = hour ? hour : 12;
  const formattedTime = `${hour}:${minutes} ${ampm}`;
  return formattedTime;
};

export function formatDateTime(inputDate) {
  const date = new Date(inputDate);
  const now = new Date();

  // Helper function to format time as `3:04 PM`
  const formatTime = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for AM/PM format
    return `${formattedHours}:${minutes} ${amPm}`;
  };

  // Check if the input date is today
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (isToday) {
    return formatTime(date);
  }

  // Check if the input date is yesterday
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);

  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) {
    return `Yesterday ${formatTime(date)}`;
  }

  // For earlier dates, return as `MM/DD/YYYY HH:MM AM/PM`
  const formattedDate = date.toLocaleDateString(); // `MM/DD/YYYY` format
  return `${formattedDate} ${formatTime(date)}`;
}

export const formatLocation = (location) => {
  if (location.length > 8) {
    return location.slice(0, 8) + "...";
  } else {
    return location;
  }
};

// const createCsv = async (data) => {
//   if (!data || data.length === 0) return "";

//   // Dynamically get keys from first object
//   let keys = Object.keys(data[0]);

//   // Optionally remove keys like __v if not needed
//   keys = keys.filter(key => key !== "__v");

//   let result = "";
//   result += keys.join(",") + "\n";

//   data.forEach((element) => {
//     keys.forEach((key, index) => {
//       let value = element[key];

//       // Format date fields including "timestamp"
//       if (
//         (key.toLowerCase().includes("date") ||
//           ["createdAt", "updatedAt", "timestamp"].includes(key)) &&
//         value
//       ) {
//         value = formatDate(value);
//       }

//       // Convert value to string-safe for CSV
//       let outputValue =
//         typeof value === "string" ? `"${value.replace(/"/g, '""')}"` :
//           typeof value === "number" || typeof value === "boolean" ? value :
//             value?._id || "N/A";

//       result += outputValue;

//       // Add comma unless it's the last column
//       if (index < keys.length - 1) result += ",";
//     });
//     result += "\n";
//   });

//   return result;
// };

// export const downloadCSV = async (name, array) => {
//   if (array?.length > 0) {
//     let csv = "data:text/csv;charset=utf-8," + (await createCsv(array));
//     let excel = encodeURI(csv);
//     let link = document.createElement("a");
//     link.setAttribute("href", excel);
//     link.setAttribute("download", `${name}.csv`);
//     link.click();
//   }
//   return;
// };

// const createCsv = async (data) => {
//   if (!data || data.length === 0) return "";

//   // Dynamically get keys from first object
//   let keys = Object.keys(data[0]);

//   // Optionally remove keys like __v if not needed
//   keys = keys.filter(key => key !== "__v");

//   let result = "";
//   result += keys.join(",") + "\n";

//   data.forEach((element) => {
//     keys.forEach((key, index) => {
//       let value = element[key];

//       // Format date fields including "timestamp"
//       if (
//         (key.toLowerCase().includes("date") ||
//           ["createdAt", "updatedAt", "timestamp"].includes(key)) &&
//         value
//       ) {
//         value = formatDate(value);
//       }

//       // Convert value to string-safe for CSV
//       let outputValue =
//         typeof value === "string" ? `"${value.replace(/"/g, '""')}"` :
//           typeof value === "number" || typeof value === "boolean" ? value :
//             value?._id || "N/A";

//       result += outputValue;

//       // Add comma unless it's the last column
//       if (index < keys.length - 1) result += ",";
//     });
//     result += "\n";
//   });

//   return result;
// };

// export const downloadCSV = async (name, array) => {
//   if (array?.length > 0) {
//     // Add UTF-8 BOM at the beginning of the CSV
//     const BOM = "\uFEFF";
//     const csvContent = await createCsv(array);
//     const csv = "data:text/csv;charset=utf-8," + BOM + csvContent;

//     const encodedUri = encodeURI(csv);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `${name}.csv`);
//     document.body.appendChild(link); // Required for Firefox
//     link.click();
//     document.body.removeChild(link);
//   }
// };

// Custom CSV formatter
const createCsv = async (data) => {
  if (!data || data.length === 0) return "";

  let keys = Object.keys(data[0]).filter(key => key !== "__v");

  const rows = [
    keys.join(","), // Header row
    ...data.map(row => {
      return keys.map(key => {
        let value = row[key];

        // Format date fields
        if (
          (key.toLowerCase().includes("date") ||
            ["createdAt", "updatedAt", "timestamp"].includes(key)) &&
          value
        ) {
          value = formatDate(value); // Make sure formatDate is defined
        }

        // Convert to CSV-safe string
        if (typeof value === "string") {
          return `"${value.replace(/"/g, '""')}"`;
        } else if (typeof value === "number" || typeof value === "boolean") {
          return value;
        } else {
          return value?._id || "N/A";
        }
      }).join(",");
    })
  ];

  return rows.join("\n");
};

// CSV download with Blob and BOM
export const downloadCSV = async (filename, data) => {
  if (!data || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  const csvString = "\uFEFF" + await createCsv(data); // Add BOM for Excel
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url); // Clean up
};

// export const downloadCSV = (filename, data) => {
//   if (!data || data.length === 0) {
//     console.warn("No data to export");
//     return;
//   }

//   const csvString = "\uFEFF" + unparse(data); // Add BOM for Excel
//   const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", `${filename}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
//   URL.revokeObjectURL(url); // Clean up
// };

export const loadGoogleMapScript = (callback) => {
  if (
    typeof (window).google === "object" &&
    typeof (window).google.maps === "object"
  ) {
    callback();
  } else {
    const googleMapScript = document.createElement("script");
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`;
    window.document.body.appendChild(googleMapScript);
    googleMapScript.addEventListener("load", callback);
  }
}

export const getLocationName = async (lat, lng) => {
  return await new Promise((resolve, reject) => {
    try {
      let latlng = new (window).google.maps.LatLng(
        lat,
        lng
      )
      var geocoder = new (window).google.maps.Geocoder()
      geocoder.geocode({ latLng: latlng }, async (results, status) => {
        resolve({ address: results[0].address_components, formatted_address: results[0].formatted_address, lat, lng })
      })
    } catch (err) {
      reject(err)
    }
  })

}

export const getLoactionsDetails = (address, formatAddress, lat, lng) => {
  let items = {}
  if (Array.isArray(address) && address.length > 0) {
    let {
      zipIndex,
      administrativeAreaIndex,
      localityIndex,
      countryIndex,
      premiseIndex,
      sublocality1,
      sublocality2,
      route,
      subpremise,
      street_number,
    } = {
      zipIndex: -1,
      administrativeAreaIndex: -1,
      localityIndex: -1,
      countryIndex: -1,
      premiseIndex: -1,
      sublocality1: -1,
      sublocality2: -1,
      route: -1,
      subpremise: -1,
      street_number: -1,
    }
    const l = address.length
    for (let index = 0; index < l; index++) {
      if (address[index].types.includes("postal_code")) {
        zipIndex = index
      } else if (address[index].types.includes("administrative_area_level_1", "political")) {
        administrativeAreaIndex = index
      } else if (address[index].types.includes("administrative_area_level_3", "locality", "political")) {
        localityIndex = index
      } else if (address[index].types.includes("country", "political")) {
        countryIndex = index
      } else if (address[index].types.includes("premise", "street_number")) {
        premiseIndex = index
      } else if (address[index].types.includes('sublocality_level_1', 'sublocality', 'political')) {
        sublocality1 = index
      } else if (address[index].types.includes('sublocality_level_2', 'sublocality', 'political')) {
        sublocality2 = index
      } else if (address[index].types.includes('route')) {
        route = index
      } else if (address[index].types.includes('subpremise')) {
        subpremise = index
      } else if (address[index].types.includes('street_number')) {
        street_number = index
      }

    }
    if (zipIndex > -1) {
      items.pin_code = address[zipIndex]?.long_name
    }
    if (administrativeAreaIndex > -1) {
      items.state = address[administrativeAreaIndex]?.long_name
    }
    if (localityIndex > -1) {
      items.city = address[localityIndex]?.long_name
    }
    if (countryIndex > -1) {
      items.country = address[countryIndex]?.long_name
    }
    if (premiseIndex > -1) {
      items.apartment_number = address[premiseIndex]?.long_name
    }
    items.street = formatAddress
    items.sublocality1 = address[sublocality1]?.long_name
    items.sublocality2 = address[sublocality2]?.long_name
    items.subpremise = address[subpremise]?.long_name
    items.route = address[route]?.long_name
    items.street_number = address[street_number]?.long_name

  }
  return items

}

export const convertToISO = (time) => {
  if (!time) return null; // Return null if there's no time
  const currentDate = new Date(); // Get the current date
  const [hours, minutes] = time.split(":"); // Split the HH:mm time string
  currentDate.setHours(hours, minutes, 0, 0); // Set the time to the current date
  // Return the ISO string in the format "YYYY-MM-DDTHH:mm:ssZ"
  return currentDate.toISOString();
};
export const formatTime = (timeString) => {
  const date = new Date(timeString);
  const hours = date.getHours().toString().padStart(2, "0"); // Ensure 2 digits
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2 digits
  return `${hours}:${minutes}`;
};

export function truncateString(str) {
  if (str.length > 15) {
    return str.substring(0, 100) + '...';
  } else {
    return str;
  }
}
